import { createTeamResourceContext } from './createTeamResourceContext'
import useTeamPackageImportsResources from '../shared/resources/api/v1/admin/packages/useTeamPackageImportsResources'

const { Provider: PackageImportsProvider, useHook: usePackageImports, useSafeHook: usePackageImportsSafe } = createTeamResourceContext({
  name: 'PackageImports',
  useResources: useTeamPackageImportsResources,
  responseKey: 'packageImports',
  requestOptions: { limit: 500 },
  lookups: [
    { key: 'packageImportsById', field: 'id' },
  ],
  groupings: [{ key: 'packageImportsByProjectId', field: 'projectId' }],
  polling: true,
})

export { PackageImportsProvider, usePackageImports, usePackageImportsSafe }
